import React, { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
export function MobileBar() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => {
      const pastHero = window.scrollY > 700;
      const inPlans = ["planes", "oferta-final"].some(id => {
        const el = document.getElementById(id);
        if (!el) return false;
        const r = el.getBoundingClientRect();
        return r.top < window.innerHeight && r.bottom > 0;
      });
      setVisible(pastHero && !inPlans);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, {
      passive: true
    });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  return <AnimatePresence data-id="element-166" data-mp="2ytoa42kh9l5a">
      {visible && <motion.div initial={{
      y: "100%"
    }} animate={{
      y: 0
    }} exit={{
      y: "100%"
    }} transition={{
      duration: 0.22,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed inset-x-0 bottom-0 z-40 border-t border-pizarra/15 bg-marfil/95 px-4 py-3 backdrop-blur md:hidden" data-id="element-167" data-mp="3mktqqjy8shgn">
          <div className="flex items-center justify-between gap-3" data-id="element-168" data-mp="2ih4ezhauceq3">
            <p className="text-sm text-pizarra" data-id="element-169" data-mp="2ierpmj2r7230">
              <span className="font-semibold text-pizarra-deep" data-id="element-170" data-mp="2x6k28nb5y211">7 · 12 · 14 ebooks</span> según el plan
            </p>
            <a href="#planes" className="whitespace-nowrap rounded-full bg-terracota-deep px-5 py-3 text-sm font-semibold text-papel" data-id="element-171" data-mp="2sd7k8w0zoth9">
              Ver planes
            </a>
          </div>
        </motion.div>}
    </AnimatePresence>;
}